// Not billable services:
export const NOT_BILLABLE_CASE_TYPES = [300, 330, 350, 360, 670];

// Case/Service statuses
export const IN_PROGRESS = 'In Progress';
export const CLOSED = 'Closed';
export const OPEN = 'Open';
export const SUBMITTED = 'Submitted';
export const SUBMITTED_DISPLAY_STATUS = 'Final Claim Submitted';
export const ABANDONED = 'Client abandoned service';

// Case/Service status actions
export const CLOSE = 'Close';
export const REOPEN = 'Re-open';

// Claim statuses
export const CLAIM_UNDER_REVIEW = 'Claim Under Review';
export const CLAIM_PENDING_APPROVAL = 'Claim Pending Approval';
export const CLAIM_SUBMITTED = 'Claim Submitted';
export const CLAIM_REJECTED = 'Claim Rejected';
export const CLAIM_APPROVED = 'Claim Approved';
export const CLAIM_WITHDRAWN = 'Claim Withdrawn';
export const CLAIM_PAYMENT_SENT = 'Claim Sent to Tipalti';
export const CLAIM_REVIEWED_BY_COUNSEL = 'Reviewed by Counsel';
export const REVIEWED_CLAIMS = 'Reviewed Claims';
export const STATUS_CHOICES = [
  CLAIM_APPROVED,
  CLAIM_PENDING_APPROVAL,
  CLAIM_REJECTED,
  CLAIM_SUBMITTED,
  CLAIM_WITHDRAWN,
  CLAIM_UNDER_REVIEW,
  CLAIM_PAYMENT_SENT,
];
export const REVIEW_STATUSES = [CLAIM_PENDING_APPROVAL, CLAIM_UNDER_REVIEW];
export const CLOSED_STATUSES = [
  CLAIM_APPROVED,
  CLAIM_REJECTED,
  CLAIM_WITHDRAWN,
  CLAIM_PAYMENT_SENT,
];
export const APPROVED_STATUSES = [CLAIM_APPROVED, CLAIM_PAYMENT_SENT];

export const CASE_STATUS_CHOICES = [
  { value: IN_PROGRESS, displayValue: IN_PROGRESS },
  { value: CLOSED, displayValue: CLOSED },
  { value: CLAIM_SUBMITTED, displayValue: SUBMITTED_DISPLAY_STATUS },
];

// Claim reviewer status
export const UNASSIGNED = 'Unassigned';

// Claim actions
export const PAID = 'paid';
export const APPROVED = 'approved';

// Query params
export const QUERY_PARAM_CLOSED = 'closed';
export const QUERY_PARAM_OPEN = 'open';

// Kick instance statuses
export const NOT_REVIEWED = 'Not reviewed';
export const DID_NOT_RUN = 'Kick did not execute';
export const KEPT = 'Claim rejected';
export const DISCARDED = 'Kick ignored';

// Kick statuses
export const IGNORE = 'Ignore';

// Kick Handling Options
export const KICK_HANDLING_OPTIONS = [
  {
    value: 'Reject',
    displayValue: 'Always keep this kick and reject the claim.',
  },
  {
    value: 'Ignore',
    displayValue: 'Always discard this kick.',
  },
  {
    value: 'Manual',
    displayValue: 'Always keep this kick and send the claim to manual review.',
  },
];

// Kick parameterType options
export const INT_TYPES = ['int', 'list_int'];
export const FLOAT_TYPES = ['float', 'list_float'];

// Overpayment Recovery
export const OVERPAYMENT_RECOVERY_STATUS_PENDING = 'pending';
export const OVERPAYMENT_RECOVERY_STATUS_RECOUPED = 'recouped';
export const OVERPAYMENT_RECOVERY_STATUS_RECOUPED_VIA_CHECK = 'recouped via check';

export const OVERPAYMENT_RECOVERY_STATUS_OPTIONS = [
  OVERPAYMENT_RECOVERY_STATUS_PENDING,
  OVERPAYMENT_RECOVERY_STATUS_RECOUPED,
  OVERPAYMENT_RECOVERY_STATUS_RECOUPED_VIA_CHECK,
];

export const SPECIAL_ARRANGEMENT_LOCATION_CODE = '20906';

export const SERVICE_CASE_TYPES_FOR_STANDARD_FEE_GUARDRAIL = [
  100, 140, 420, 430, 442, 460, 520, 540, 560, 630, 710, 770, 780, 830,
];
